import { render, staticRenderFns } from "./AccessibilityDeclaration.vue?vue&type=template&id=1dcb4346&scoped=true&"
import script from "./AccessibilityDeclaration.vue?vue&type=script&lang=js&"
export * from "./AccessibilityDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityDeclaration.vue?vue&type=style&index=0&id=1dcb4346&scoped=true&lang=scss&"
import style1 from "./AccessibilityDeclaration.vue?vue&type=style&index=1&id=1dcb4346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb4346",
  null
  
)

export default component.exports